import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const Fold = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 48 48"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <defs>
            <clipPath id="bb499__a">
              <rect
                rx="0"
                height="48"
                width="48"
                y="48"
              />
            </clipPath>
          </defs>
          <g
            clipPath="url(#bb499__a)"
            transform="matrix(1 0 0 -1 0 96)"
            style={{ mixBlendMode: 'passthrough' }}
          >
            <path
              fillRule="evenodd"
              d="M8 60.5h32a2 2 0 0 0 0-4H8a2 2 0 0 0 0 4ZM18 77a2 2 0 0 1-3.06 1.696l-8-5a2 2 0 0 1 0-3.392l8-5A2 2 0 0 1 18 67v10Zm22-7.5H24a2 2 0 1 1 0-4h16a2 2 0 0 1 0 4Zm-16 9h16a2 2 0 0 0 0-4H24a2 2 0 1 0 0 4Zm18 7a2 2 0 0 1-2 2H8a2 2 0 1 1 0-4h32a2 2 0 0 1 2 2Z"
              data-follow-fill="#455766"
              fill={_fill}
            />
          </g>
        </g>
      </svg>
    )
  }
)
